import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, Field, reduxForm } from 'redux-form';
import FieldInput from '../../form/FieldInput';
import { validateEmail } from '../../form/validators';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Message from '../../../common/message/Message';
import focusDelay from '../../helpers/focusDelay';
import {
	ONBOARDING_FORGOT_PASSWORD_TITLE,
	ONBOARDING_FORGOT_PASSWORD_SUBTITLE,
	ONBOARDING_LOGIN_EMAIL_FIELD,
	ONBOARDING_FORGOT_PASSWORD_CTA,
} from '../../../../constants/Copy';

const selector = formValueSelector('forgotPassword');

const EmailResetLinkForm = ({ handleSubmit, submitting, email }) => {
	useEffect(() => {
		focusDelay(email, false);
	}, [email]);

	return (
		<form method="post" className="onboarding__form" onSubmit={handleSubmit}>
			<Heading>
				<Message message={ONBOARDING_FORGOT_PASSWORD_TITLE} />
			</Heading>

			<p className="onboarding__form--message">
				<Message message={ONBOARDING_FORGOT_PASSWORD_SUBTITLE} />
			</p>

			<Field
				name="email"
				type="email"
				element={(element) => (email = element)}
				testId="forgot-password-input"
				component={FieldInput}
				label={ONBOARDING_LOGIN_EMAIL_FIELD}
			/>

			<Button
				type="submit"
				disabled={!email || email.length === 0}
				loading={submitting}
				testId="forgot-password-button"
			>
				{ONBOARDING_FORGOT_PASSWORD_CTA}
			</Button>
		</form>
	);
};

EmailResetLinkForm.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
	email: PropTypes.string,
};

EmailResetLinkForm.defaultProps = {
	email: null,
};

const WrappedEmailResetLinkForm = reduxForm({
	form: 'forgotPassword',
	validate: validateEmail,
	destroyOnUnmount: false, // Maintain state so other forms might use it
	enableReinitialize: true,
})(EmailResetLinkForm);

const mapStateToProps = (state) => ({
	email: selector(state, 'email'),
});

export default connect(mapStateToProps)(WrappedEmailResetLinkForm);
